
import { Component, ComponentFactoryResolver, Inject, ViewContainerRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog'; // If you're using Angular Material Dialog
import { EditBreaksComponent } from '../../edit-breaks/edit-breaks.component';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
@Component({
  selector: 'edit-btn-cell-renderer',
  template: `
    <span class="detailiconhome">
      <img
        class="img-tool"
        *ngIf="access || access1"
        src="./assets/images/edit.svg"
        alt="edit button icon"
        title="Edit"
        (click)="onEditClick()"
      />
    </span>
  `,
})
// (click)="btnClickedHandler($event)"
// *ngIf="editable"

export class EditBtnCellRender implements ICellRendererAngularComp {
   private params: any;
  access;
  access1


  constructor(
    private vcr: ViewContainerRef,  // This is needed for dynamically adding components
    private cfr: ComponentFactoryResolver // Component Factory Resolver
  ) {}

  agInit(params: ICellRendererParams): void {
    this.access = JSON.parse(localStorage.getItem('shiftAccess1'));
    this.access1 = JSON.parse(localStorage.getItem('shiftAccess2'));

    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  // This function is for handling the click event of the "Edit" button
  onEditClick():void {
    this.params.clicked(this.params.data)
  }


}